import { CartesianChartSpecTransformer } from "../cartesian";

import { setDefaultCrosshairForCartesianChart } from "../util";

export class MosaicChartSpecTransformer extends CartesianChartSpecTransformer {
    _getDefaultSeriesSpec(spec) {
        return super._getDefaultSeriesSpec(spec, [ "barWidth", "barMaxWidth", "barMinWidth", "barGapInGroup", "barBackground", "barMinHeight", "stackCornerRadius", "bar", "bandWidthField" ]);
    }
    transformSpec(spec) {
        super.transformSpec(spec), setDefaultCrosshairForCartesianChart(spec);
    }
    _setDefaultXAxisSpec(spec) {
        return {
            orient: "bottom",
            type: "linear",
            label: {
                visible: !1
            }
        };
    }
    _setDefaultYAxisSpec(spec) {
        return {
            orient: "left",
            type: "linear"
        };
    }
}
//# sourceMappingURL=mosaic-transformer.js.map
